import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { useUserProfile } from './useUserProfile';
import { schoolsDB } from '../lib/db/schools';

/**
 * Hook to get the school logo for the current user
 * Returns the logo URL if available, null otherwise
 * Uses cached school data for performance
 */
export const useSchoolLogo = () => {
  const { currentUser } = useAuth();
  const { userProfile } = useUserProfile();
  const [schoolLogo, setSchoolLogo] = useState(null);

  useEffect(() => {
    const fetchSchoolLogo = async () => {
      if (!currentUser || !userProfile) {
        setSchoolLogo(null);
        return;
      }

      const schoolId = userProfile?.profile?.schoolId;
      if (!schoolId) {
        setSchoolLogo(null);
        return;
      }

      try {
        // This will use cached data if available
        const school = await schoolsDB.getSchool(schoolId);
        setSchoolLogo(school?.logo || null);
      } catch (error) {
        console.error('Error fetching school logo:', error);
        setSchoolLogo(null);
      }
    };

    fetchSchoolLogo();
  }, [currentUser, userProfile]);

  return schoolLogo;
};

